// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d6c3bd1a","239":"682c4a50","453":"7aa3cf3a","455":"42043400","762":"3cc08dc9"}[chunkId] + ".chunk.js";
};